// Customizable Area Start
import React, { Component } from "react"
import ReactDOM from "react-dom"
import { Box, CircularProgress, styled } from "@mui/material"

const Overlay = styled("div")({
  top: 0,
  left: 0,
  width: "100%",
  position: "fixed",
  height: "100%",
  backgroundColor: "rgba(15, 23, 42, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1600,
})

const LoaderWrapper = styled(Box)({
  position: "relative",
  display: "inline-flex",
})

const ForegroundProgress = styled(CircularProgress)({
  color: "#fff",
  "& circle": { strokeLinecap: "round" },
})

const BackgroundProgress = styled(CircularProgress)({
  position: "absolute",
  color: "rgba(255, 255, 255, 0.15)",
})

interface Props {
  isLoading: boolean
}

class FullPageLoader extends Component<Props> {
  componentDidMount() {
    if (this.props.isLoading) {
      this.lockBodyScroll();
    }
  }
  
  componentDidUpdate(prevProps: Props) {
    if (prevProps.isLoading !== this.props.isLoading) {
      this.props.isLoading ? this.lockBodyScroll() : this.unlockBodyScroll();
    }
  }
  
  componentWillUnmount() {
    this.unlockBodyScroll();
  }
  
  lockBodyScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    document.body.classList.add("scroll-lock");
  }
  
  unlockBodyScroll() {
    document.body.classList.remove("scroll-lock");
    document.body.style.removeProperty('--scrollbar-width');
  }

  renderLoader() {
    return (
      <Overlay>
        <LoaderWrapper>
          <BackgroundProgress
            size={40}
            thickness={4.5}
            variant="determinate"
            value={100}
          />
          <ForegroundProgress size={40} thickness={4.5} />
        </LoaderWrapper>
      </Overlay>
    )
  }

  render() {
    const { isLoading } = this.props
    return isLoading ? ReactDOM.createPortal(this.renderLoader(), document.body) : null
  }
}

export default FullPageLoader
// Customizable Area End
